<template>
  <router-view/>
</template>

<script>
export default {
  name: 'PageIndex'
}
</script>



// WEBPACK FOOTER //
// src/pages/index.vue